package org.hs_soft.runmynesto.domain.usecase.options.export

import org.hs_soft.runmynesto.domain.model.home.options.export.option_credit_card.OptionCreditCardModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.OptionCreditCardRepository

class OptionCreditCardUseCase(
    private val optionCreditCardRepository: OptionCreditCardRepository
) {
    suspend operator fun invoke(): OptionCreditCardModel {
        return optionCreditCardRepository.getOptionCreditCards()
    }
} 